import styled from 'styled-components';

export const RetirementsContainer = styled.div`
  padding: 3rem 2rem;
  background: var(--surface-glass);
  border-radius: 20px;
  margin: 2rem 0;
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-subtle);

  @media (max-width: 768px) {
    padding: 2rem 1rem;
    margin: 1rem 0;
  }
`;

export const RetirementsTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--text-heading);
  text-align: center;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px var(--surface-overlay);
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const RetirementsSubtitle = styled.p`
  font-size: 1.2rem;
  color: var(--text-secondary);
  text-align: center;
  margin-bottom: 2.5rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const FilterContainer = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: var(--surface-1);
  border-radius: 15px;
  border: 2px solid var(--accent);
  box-shadow: var(--shadow-sm);
`;

export const FilterStats = styled.div`
  font-size: 1rem;
  color: var(--text-primary);
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  font-weight: 500;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

export const FilterInfo = styled.div`
  font-size: 0.9rem;
  color: var(--text-secondary);
  font-style: italic;
  padding: 0.8rem;
  background: var(--accent-soft);
  border-radius: 8px;
  border: 1px solid var(--border-default);
  font-weight: 500;
  text-align: center;
`;

export const RetirementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 1.8rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;

export const RetirementsListGrid = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

// Novo design de card
export const Card = styled.article`
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  border-radius: 16px;
  padding: 16px 18px;
  box-shadow: var(--shadow-sm);
  display: grid;
  gap: 12px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }

  @media (max-width: 1024px) {
    padding: 15px 16px;
    gap: 11px;
  }

  @media (max-width: 768px) {
    padding: 14px 16px;
    gap: 10px;
  }

  @media (max-width: 480px) {
    padding: 12px 14px;
    gap: 8px;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;

  @media (max-width: 1024px) {
    gap: 10px;
  }

  /* SOLUÇÃO ESPECÍFICA PARA 1366x768 */
  @media (max-width: 1366px) and (min-width: 1025px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 1.05rem;
  color: var(--text-primary);
  font-weight: 700;
  word-break: break-word;
  flex: 1;
  line-height: 1.3;
  min-width: 0; /* Permite que o texto quebre corretamente */

  @media (max-width: 1024px) {
    font-size: 1rem;
    line-height: 1.25;
    max-width: 100%;
  }

  /* SOLUÇÃO ESPECÍFICA PARA 1366x768 */
  @media (max-width: 1366px) and (min-width: 1025px) {
    font-size: 1rem;
    line-height: 1.25;
    max-width: 100%;
    width: 100%;
    flex: none; /* Remove flex para usar toda a largura */
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.2;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
  }
`;

export const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
  flex-shrink: 0; /* Evita que as badges encolham */

  @media (max-width: 1024px) {
    gap: 5px;
    max-width: 40%; /* Limita o espaço ocupado pelas badges */
  }

  /* SOLUÇÃO ESPECÍFICA PARA 1366x768 */
  @media (max-width: 1366px) and (min-width: 1025px) {
    justify-content: flex-start;
    gap: 8px;
    max-width: 100%; /* Usa toda a largura disponível */
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    gap: 8px;
    max-width: 100%; /* Em mobile, usa toda a largura */
  }

  @media (max-width: 480px) {
    gap: 6px;
  }
`;

export const Badge = styled.span`
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 999px;
  background: var(--accent-secondary-soft);
  color: var(--accent-secondary);
  font-weight: 600;
  white-space: nowrap;

  @media (max-width: 1024px) {
    font-size: 0.7rem;
    padding: 3px 6px;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
    padding: 3px 6px;
  }
`;

export const SubBadge = styled(Badge)`
  background: var(--surface-3);
  color: var(--text-secondary);
  font-weight: 600;
`;

/* Quantity em destaque — gradiente de marca com texto branco fixo. */
export const QuantityHighlight = styled.div`
  background: var(--brand-cta-gradient-135);
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  color: var(--text-on-brand);
  box-shadow: var(--shadow-sm);
  margin: 0.5rem 0;

  .quantity-value {
    display: block;
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0.25rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .quantity-label {
    display: block;
    font-size: 0.9rem;
    font-weight: 500;
    opacity: 0.95;
  }

  @media (max-width: 768px) {
    .quantity-value {
      font-size: 1.5rem;
    }
    
    .quantity-label {
      font-size: 0.8rem;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
  
  @media (max-width: 1024px) {
    gap: 9px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

export const Field = styled.div`
  small {
    display: block;
    color: var(--text-secondary);
    font-weight: 700;
    margin-bottom: 4px;
    font-size: 0.8rem;
  }
  
  p {
    margin: 0;
    color: var(--text-primary);
    word-break: break-word;
    overflow-wrap: anywhere;
    font-size: 0.9rem;
    line-height: 1.4;
  }

  @media (max-width: 1024px) {
    small {
      font-size: 0.78rem;
      margin-bottom: 3px;
    }
    
    p {
      font-size: 0.88rem;
      line-height: 1.35;
    }
  }

  @media (max-width: 480px) {
    small {
      font-size: 0.75rem;
      margin-bottom: 3px;
    }
    
    p {
      font-size: 0.85rem;
      line-height: 1.3;
    }
  }
`;

export const LongText = styled.p`
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${p => (p.$expanded ? 'unset' : 2)};
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.4;

  @media (max-width: 1024px) {
    line-height: 1.35;
  }

  @media (max-width: 480px) {
    line-height: 1.3;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 4px;
  
  button, a {
    border: 1px solid var(--border-default);
    background: var(--accent);
    color: var(--text-on-accent);
    padding: 6px 10px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.85rem;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: var(--accent-hover);
      transform: translateY(-1px);
    }
  }
  
  button.secondary {
    background: var(--surface-2);
    color: var(--text-secondary);
    border-color: var(--border-subtle);
    
    &:hover {
      background: var(--surface-3);
    }
  }

  @media (max-width: 1024px) {
    gap: 7px;
    margin-top: 5px;
    
    button, a {
      padding: 6px 9px;
      font-size: 0.83rem;
      border-radius: 9px;
    }
  }

  @media (max-width: 480px) {
    gap: 6px;
    margin-top: 6px;
    
    button, a {
      padding: 5px 8px;
      font-size: 0.8rem;
      border-radius: 8px;
    }
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid var(--accent-soft);
  border-top: 4px solid var(--accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ErrorMessage = styled.div`
  background: var(--surface-2);
  color: var(--danger);
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  border: 1px solid var(--danger);
  font-size: 1.1rem;
`;

export const NoResultsMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: var(--text-secondary);
  font-size: 1.1rem;
  background: var(--surface-glass);
  border-radius: 10px;
  margin: 1rem 0;
`;
